import { jsx as _jsx } from "react/jsx-runtime";
const icons = {
  dgLogo: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/akameeyg.bde.svg',
  dsLogo: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/hanv5lb3.a35.svg',
  gvaLogo: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/lcmw423p.b3d.svg',
  hbvlLogo: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/ekbqu1qf.hcg.svg',
  nbLogo: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/dxqrkoqp.pju.svg',
  plus: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/2tobkzq1.pqo.svg',
  plusBlack: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/phrfjgic.h5c.svg'
};
const MultibrandIcon = _ref => {
  let {
    height,
    icon,
    width
  } = _ref;
  return /*#__PURE__*/_jsx("img", {
    src: icons[icon],
    height: height,
    width: width
  });
};
export default MultibrandIcon;